import ToggleSwitch from './ToggleSwitch';

export default ToggleSwitch;